<ng-container *ngrxLet="resultsInfos$ as resultsInfos">
    @if (resultsInfos) {
        @if (resultsInfos) {
            <div class="results-info">
                @for (playerInfo of resultsInfos; track playerInfo) {
                    @if (playerInfo) {
                        <tp-results-info [resultsPlayerInfo]="playerInfo"> </tp-results-info>
                    }
                }
            </div>
        }
    }
</ng-container>
